{"id":"CurrentVenueName","prefabs":{"default":{"children":[{"component":"CurrentVenueName","options":"options:*"}]}}}